import { render, staticRenderFns } from "./merchant-app-detail.vue?vue&type=template&id=98053f84&scoped=true"
import script from "./merchant-app-detail.vue?vue&type=script&lang=js"
export * from "./merchant-app-detail.vue?vue&type=script&lang=js"
import style0 from "./merchant-app-detail.vue?vue&type=style&index=0&id=98053f84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98053f84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98053f84')) {
      api.createRecord('98053f84', component.options)
    } else {
      api.reload('98053f84', component.options)
    }
    module.hot.accept("./merchant-app-detail.vue?vue&type=template&id=98053f84&scoped=true", function () {
      api.rerender('98053f84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/develop-manage/merchant-app-detail.vue"
export default component.exports